export default "__VITE_ASSET__DX4HVyBL__"